import { render, staticRenderFns } from "./SVGPhotoDnDLoad.vue?vue&type=template&id=6e9513b6&scoped=true&"
import script from "./SVGPhotoDnDLoad.vue?vue&type=script&lang=js&"
export * from "./SVGPhotoDnDLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9513b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e9513b6')) {
      api.createRecord('6e9513b6', component.options)
    } else {
      api.reload('6e9513b6', component.options)
    }
    module.hot.accept("./SVGPhotoDnDLoad.vue?vue&type=template&id=6e9513b6&scoped=true&", function () {
      api.rerender('6e9513b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGPhotoDnDLoad.vue"
export default component.exports